import { formatNumber } from '@core/design-system/utils/format-number';
import { IndicatorType } from './constants';

export const calcProfitabilityByType = ({
  type,
  asset,
  benchmark,
  formatDecimal,
}: {
  type: IndicatorType;
  asset: number;
  benchmark: number;
  formatDecimal: boolean;
}): string | number => {
  const multiplier = formatDecimal ? 100 : 1;

  switch (type) {
    case IndicatorType.VALUE:
      return formatNumber(benchmark * multiplier, {
        type: 'percent',
      });
    case IndicatorType.RELATIVE_PERCENTAGE:
      return formatNumber((asset / benchmark) * 100, {
        type: 'percent',
      });
    case IndicatorType.PERCENTAGE_POINTS:
      return formatNumber((asset - benchmark) * multiplier, {
        precision: 2,
      });
    default:
      return benchmark;
  }
};

export const niceNameByType = (type: IndicatorType, nicename: string) => {
  switch (type) {
    case IndicatorType.VALUE:
      return nicename?.toUpperCase();
    case IndicatorType.RELATIVE_PERCENTAGE:
      return `% ${nicename?.toUpperCase()}`;
    case IndicatorType.PERCENTAGE_POINTS:
      return `p.p. acima ${nicename?.toUpperCase()}`;
    default:
      return '';
  }
};
